import { ProfileActionTypes, ProfileMutationTypes } from './types';
import { notifySuccess } from '../../helpers/notifications';

export const actions = {
    async [ProfileActionTypes.GetProfile]({commit}, { params } = {}) {
        return new Promise((resolve, reject) => {
            this.$api.getRecipientProfile.get({
                params: { ...params },
            }).then(response => {
                const profile = response && response.data && response.data.data
                if (profile && (profile.profile === 0 || profile.profile === 1)) {
                    commit(`${ProfileMutationTypes.SetProfile}`, { profile })
                    resolve(response)
                } else {
                    reject(response)
                }
            })
            .catch((error) => {
                reject(error)
            })
        })
    },
    async [ProfileActionTypes.AddProfile](context, { data } = {}) {
        return new Promise((resolve, reject) => {
            this.$api.addRecipientProfile.post({
                body: { ...data },
            }).then(response => {
                if (response && response.data) {
                    notifySuccess({ title: response.data.message })
                    resolve(response)
                }
            })
            .catch((error) => {
                reject(error)
            })
            .finally((response) => {
                resolve(response)
            })
        })
    },
    async [ProfileActionTypes.EditProfile]({commit}, { data } = {}) {
        return new Promise((resolve, reject) => {
            this.$api.editRecipientProfile.patch({
                body: { ...data },
            }).then(response => {
                if (response?.data) {
                    commit(`${ProfileMutationTypes.SetProfile}`, { profile: response.data.data })
                    notifySuccess({ title: response.data.message })
                    resolve(response)
                }
            })
            .catch((error) => {
                reject(error)
            })
        })
    },
}